<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal--store-header modal modal--welcomeback modal--zero-balance " id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="usericon" src="static/images/happy_face_2.svg" alt="">
        </div>
        <div class="modal__body">
          <p class="modal_strong">
            {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
              {{ getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_and:'' }}
             {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_points:''}}
            – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_playing_more }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_are_you_sure_you_want_to_continue }}</p>
        </div>
        <div class="modal__footer">
          <a style="cursor:pointer"
             :class="['btn2 btn2--std btn2--small btn2--fixed',(!buttonEnabled) ? 'deactivated' : '']"
             @click.prevent="purchaseBundle()">
            {{ getTranslations.home_modals_confirm_purchase_purchase_now_button }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import FailedPurchase from './FailedPurchase';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import FailedPurchaseOperator from './FailedPurchaseOperator';

export default {
  name: 'confirmPurchase',
  data() {
    return {
      showedModal: false,
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            console.log("----------------------- Correct ConfirmPurchaseForPin For  Store showHideModal");
            this.showedModal = true;
            this.storeModalForStore(null);
          } else {
            this.storeModalForStore(null);
          }
        });
      });
      /* eslint-enable */
    },
    purchaseBundle() {
      this.buttonEnabled = false;
      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: null,
        };
        this.chargePinCall({ value: bundleInfo }).then(() => {
          this.buttonEnabled = true;
          // eslint-disable-next-line
          console.log("----------------------- Correct ConfirmPurchase For  Store showHideModal" + this.chargePinResponse);
          if (this.chargePinResponse === 'OPERATION_SUCCESS') {
            this.$emit('bundlePurchase');
            this.storeModalForStore(ConfirmPurchaseSuccessful);
          } else if (this.integrationHeader === this.availableIntegrations.ETISALAT_AFG.name && this.chargePinResponse === 'PENDING') {
            this.$emit('bundlePurchase');
            this.storeModalForStore(ConfirmPurchaseSuccessful);
          } else if (this.chargePinResponse === 'BILLING_FAILED') {
            this.storeModalForStore(FailedPurchaseOperator);
          } else if (this.chargePinResponse === 'NO_BALANCE') {
            this.storeModalForStore(FailedPurchase);
          } else {
            this.storeModalForStore(FailedPurchaseOperator);
          }
          this.showModal();
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchase.vue